import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyDeliveryOrder from '../components/addEditCopyDeliveryOrder/index.vue';

var AddThirdPartDeliveryOrderPage = function (_super) {
  __extends(AddThirdPartDeliveryOrderPage, _super);

  function AddThirdPartDeliveryOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddThirdPartDeliveryOrderPage = __decorate([Component({
    components: {
      AddEditCopyDeliveryOrder: AddEditCopyDeliveryOrder
    }
  })], AddThirdPartDeliveryOrderPage);
  return AddThirdPartDeliveryOrderPage;
}(Vue);

export default AddThirdPartDeliveryOrderPage;